import {graphql, useStaticQuery} from 'gatsby';
import React from 'react';
import LayoutPortfolio from '../components/layout-portfolio';

function LayoutContainerPortfolio(props) {
    const data = useStaticQuery(graphql `
        query SiteTitleQueryPortfolio {
            site: sanitySiteSettings(_id: { regex: "/(drafts.|)siteSettings/" }) {
                title
            }
        }
      `);
    return (<LayoutPortfolio {...props} siteTitle={data.site.title}/>);
};

export default LayoutContainerPortfolio;
